/* ==========================================================================

  Events

  Author:     Stephen Zsolnai (http://www.zolla.co.uk)
  Decription: Event emitter that can be used everywhere it is needed. Similar to Observable pattern.
              Require event in a module and then listen using the on method.
              Events are prefixed with a namespace to negate cross event naming eg: 'UI:scroll'.
              This module allows us to listen to events like $('window').on('scroll') etc in one place and creates custom events for them.
              Mediator js is a singleton and can be assessed anywhere and listeners can be added and removed at anytime in any place.

              Add events here (this could be improved or documented elsewhere?):

              UI EVENT LIST:

              UI:DOMContentLoaded
              UI:scroll
              UI:load
              UI:resize

========================================================================== */
'use strict';
var mediator = require('./mediator'),
  _ = require('underscore'),
  utilities = require('./utilities'),
  config = require('./config'),
  $global = require('./globalElements'),
  $window = $global.$window,

  DEBOUNCE_INTERVAL = 150,
  THROTTLE_INTERVAL = 20,

  fireUiEvent = function(ev) {
    mediator.mediator.trigger('UI:' + ev.type);
  };


class UiEvents {

  constructor() {
    this.attachListeners();
  }

  attachListeners() {
    console.log('attaching ui events');
    $window.on('scroll', _.debounce(_.bind(fireUiEvent, this), DEBOUNCE_INTERVAL));
    $window.on('scroll', _.throttle(_.bind(fireUiEvent, this, { type: 'scroll:throttle' }), THROTTLE_INTERVAL));
    $window.on('DOMContentLoaded', _.bind(fireUiEvent, this));
    $window.on('load', _.bind(fireUiEvent, this));
    $window.on('resize', _.debounce(_.bind(fireUiEvent, this), DEBOUNCE_INTERVAL));
    $window.on('resize', _.throttle(_.bind(fireUiEvent, this, { type: 'resize:throttle' }), THROTTLE_INTERVAL));

    // Overlay removed if complete page state restored by the browser on history navigation (back-forward cache)
    $window.on('pageshow', function(event) {
      if (event.originalEvent.persisted) {
        $global.$body.removeClass(config.classes.reloading);
      }
    });

    $global.$document.ajaxError(utilities.ajaxErrorHandler);
    // Fix for navigation triggering ajax errors in FF
    window.onbeforeunload = function() { config.isNavigatingAway = true; };

    mediator.on(config.events.requestPageReload, _.bind(this.reloadPage, this));
    mediator.on(config.events.pageReloading, _.bind(this.reloadingPage, this));
  }

  reloadPage(url) {
    this.reloadingPage();
    if (url) {
      window.location = url;
    } else {
      window.location.reload(true);
    }
  }

  reloadingPage() {
    $global.$body.addClass(config.classes.reloading);
  }

}

module.exports = new UiEvents();



// WEBPACK FOOTER //
// ./assets/js/uievents.js